module.exports = {
    components: {
        accordion: require("src/components/accordion"),
        badge: require("src/components/badge"),
        banner: require("src/components/banner"),
        button: require("src/components/button"),

        dialog: require("src/components/dialog"),
        dropdown: require("src/components/dropdown"),
        header: require("src/components/header"),
        icon: require("src/components/icon"),
        icon_button: require("src/components/icon_button"),
        inline_message: require("src/components/inline_message"),
        link: require("src/components/link"),
        nav_toggle: require("src/components/nav_toggle"),
        pagination: require("src/components/pagination"),
        // table: require("src/components/table"),
        tabs: require("src/components/tabs"),
        tooltip: require("src/components/tooltip"),
        filter_tags: require("src/components/filter_tags"),
        // form elements
        input: require("src/components/form/input"),
        time: require("src/components/form/time"),
        date: require("src/components/form/date"),
        checkbox: require("src/components/form/checkbox"),
        radio: require("src/components/form/radio"),
        inputs_group: require("src/components/form/inputs_group"),
        toggle: require("src/components/form/toggle"),
        split_toggle: require("src/components/form/split_toggle"),
    },
    tokens: {
        index: require("src/tokens/index.css"),
        shared_components_style: require("src/tokens/shared_components_style.css")
    },
    foundation: {
        logos: {
            swift_dark_green: require("src/foundations/logos/Swift_Logo_RGB_Dark_Green.svg"),
            swift_peppermint: require("src/foundations/logos/Swift_Logo_RGB_Peppermint.svg"),
            swift_white: require("src/foundations/logos/Swift_Logo_RGB_White.svg")
        }
    }
};
